
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { AppTextColor, AppTextName } from '@shared/ui/typography'
import type { TutorBillingTableTone } from '../model/types'

import { TutorBillingExportType } from '@brighterly/lib-core-types/tutor/enums'

import { TutorStatus } from '@shared/config'

import { TutorBillingChangeType, TutorBillingDatePreset, TutorBillingFlag } from '../model/enums'

export const TUTOR_BILLING_FLAG_LABELS: Record<TutorBillingFlag, string> = {
  [TutorBillingFlag.Checked]: 'Legal check',
  [TutorBillingFlag.AgreementSent]: 'Agreement sent',
  [TutorBillingFlag.AgreementSigned]: 'Agreement signed',
  [TutorBillingFlag.SalesforceAccount]: 'Salesforce account',
  [TutorBillingFlag.IssuesDetected]: 'Issues detected',
}

export const TUTOR_BILLING_FLAGS: TutorBillingFlag[] = Object.values(TutorBillingFlag)

export const TUTOR_BILLING_BULK_FLAGS: TutorBillingFlag[] = TUTOR_BILLING_FLAGS
  .filter(flag => flag !== TutorBillingFlag.SalesforceAccount)

export const TUTOR_BILLING_DOT_FLAGS: TutorBillingFlag[] = [
  TutorBillingFlag.Checked,
  TutorBillingFlag.AgreementSent,
  TutorBillingFlag.AgreementSigned,
  TutorBillingFlag.SalesforceAccount,
]

export const TUTOR_BILLING_CHANGE_TYPE_OPTIONS: AppSelectOption<TutorBillingChangeType>[] = [
  { value: TutorBillingChangeType.NewAccount, text: 'New account' },
  { value: TutorBillingChangeType.ChangePending, text: 'Change pending' },
]

export const TUTOR_BILLING_DATE_PRESET_OPTIONS: AppSelectOption<TutorBillingDatePreset>[] = [
  { value: TutorBillingDatePreset.Today, text: 'Today' },
  { value: TutorBillingDatePreset.Yesterday, text: 'Yesterday' },
  { value: TutorBillingDatePreset.Last7Days, text: 'Last 7 days' },
  { value: TutorBillingDatePreset.Last30Days, text: 'Last 30 days' },
  { value: TutorBillingDatePreset.ThisMonth, text: 'This month' },
  { value: TutorBillingDatePreset.LastMonth, text: 'Last month' },
  { value: TutorBillingDatePreset.ThisYear, text: 'This year' },
  { value: TutorBillingDatePreset.Custom, text: 'Custom range' },
]

export const TUTOR_BILLING_TUTOR_STATUS_ORDER: TutorStatus[] = [
  TutorStatus.Active,
  TutorStatus.Onboarding,
  TutorStatus.Disabled,
  TutorStatus.Draft,
]

export const TUTOR_BILLING_EXPORT_COLUMNS: Record<TutorBillingExportType, string[]> = {
  [TutorBillingExportType.Gcash]: [
    'Payment Information Name', 'Company', 'Company Address', 'Account number', 'Email',
    'Beneficiary reference', 'Payer', 'VAT Number', 'Legal Entity', 'Legal Entity Account Number', 'Country',
  ],
  [TutorBillingExportType.PaypalPayoneer]: [
    'Payment Information Name', 'Company', 'Company Address', 'Account number', 'Currency',
    'Payer', 'VAT Number', 'Legal Entity', 'Country',
  ],
  [TutorBillingExportType.NewAccounts]: [
    'Admin ID', 'Account Name', 'Project', 'Region Name', 'Cooperation Status', 'Corporate Email',
    'Payment System', 'Payment period', 'Classification', 'Titan Project', 'Legal Person Name',
    'Legal Entity Name', 'Passport/Business License', 'Country',
  ],
}

export const TUTOR_BILLING_EXPORT_PREVIEW_ROWS = 5

export const TUTOR_BILLING_EXPORT_TYPE_OPTIONS: AppSelectOption<TutorBillingExportType>[] = [
  { value: TutorBillingExportType.Gcash, text: 'GCash' },
  { value: TutorBillingExportType.PaypalPayoneer, text: 'PayPal / Payoneer' },
  { value: TutorBillingExportType.NewAccounts, text: 'New accounts' },
]

export const TUTOR_BILLING_BULK_LIMIT = 100

export const TUTOR_BILLING_DEFAULT_PER_PAGE = 25

export const TUTOR_BILLING_TABLE_TONE_TEXT: Record<TutorBillingTableTone, { name: AppTextName, color: AppTextColor }> = {
  default: { name: 'body1', color: 'slate-900' },
  muted: { name: 'body1', color: 'slate-400' },
  accent: { name: 'body1-medium', color: 'emerald-700' },
}
